/**
 * The College object.
 */
export class College {

	public id:              number;     // The ID of the college in the Angular ReST API.
	public name:            string;     // The college's name. ("Carnegie-Mellon")


	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}





// WEBPACK FOOTER //
// ./src/app/services/college/college.ts